import {Component, inject} from '@angular/core'
import {MatCard, MatCardActions, MatCardContent} from '@angular/material/card'
import {SelectedComponent} from '../../components/selected/selected.component'
import {DocumentService} from '../../services/document.service'
import {TryAgainComponent} from '../error/try-again/try-again.component'

@Component({
  selector: 'spb-done',
  templateUrl: './done.component.html',
  styleUrl: './done.component.scss',
  imports: [
    TryAgainComponent,
    MatCard,
    SelectedComponent,
    MatCardActions,
    MatCardContent
  ]
})

export class DoneComponent {
  public documentService = inject(DocumentService)
}
